/**
 * A small dot-grid grip, standing in for a drag handle.
 *
 * Shared by every floating panel that can be moved — the Help videos dock and the guided-help
 * coach-mark — so "this thing is draggable" reads the same wherever it's offered.
 */
export function GripGlyph() {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" aria-hidden="true" style={{ flex: "none", color: "var(--text-faint)" }}>
      {[3, 9].flatMap((x) => [2, 9, 16].map((y) => <circle key={`${x}:${y}`} cx={x} cy={y} r="1.4" fill="currentColor" />))}
    </svg>
  );
}
